import { PositionConfig } from "slotworks/config/asset-config-schema";
import AnimationManager from "slotworks/graphics/animation/animation-manager";
import ButtonElement from "slotworks/graphics/elements/button-element";
import GraphicsManager from "slotworks/graphics/graphics-manager";
import Layers from "slotworks/graphics/layers/layers";

export function generateButton(id: string, config: PositionConfig, layer: Layers) {
    const idParts = id.split("-");
    const buttonId = idParts[0];
    const buttonState = idParts.length > 1 ? idParts[1] : "up";

    let button = layer.getButton(buttonId);

    if (!button) {
        button = new ButtonElement();
        button.name = buttonId;
        button.x = config.x;
        button.y = config.y;
        layer.container.addChildAt(button, 0);
        layer.addButton(buttonId, button);
    }

    let sprite;
    if (buttonState === "up" && AnimationManager.hasAnimation(id)) {
        sprite = AnimationManager.generateAnimation(id);
        sprite.play();
    } else {
        sprite = GraphicsManager.createSprite(config.id);
    }

    sprite.x = config.x - button.x;
    sprite.y = config.y - button.y;
    sprite.width = config.width;
    sprite.height = config.height;

    if (buttonState === "hit") {
        button.setHitArea(sprite);
    } else {
        button.addState(buttonState, sprite);
    }
    sprite.name = id;
}
